module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e18-70e74ac94fc1389d544e0d75fb55704f.jpg";